import { SvgIcon } from "@material-ui/core";

export const AtdpFileSend = (props: any) => (
  <SvgIcon {...props} width="11.529" height="14" viewBox="0 0 14 12">
    <path id="Icon_material-send-2" data-name="Icon material-send" d="M3.007,16.5,17,10.5,3.007,4.5,3,9.167,13,10.5,3,11.833Z" transform="translate(-3 -4.5)" fill="#009bdd"/>
  </SvgIcon>
);
